export default __webpack_public_path__ + "static/media/arrow-left.dac72f2a.svg";